export const environment = {
    production: false,
    reCaptchaSiteKey: '6LcQDBYrAAAAAA-NKnvFKpAh_ksMqZa6BB0I5Zff'
};
